import { Modal } from 'react-bootstrap';
import './SusyCarouselModal.css';

export interface SusyCarouselModalProps {
    show: boolean;
    size?: 'sm' | 'lg' | 'xl' | undefined;
    ariaLabelledBy: string;
    centered: boolean;
    id: string;
    dataTestId: string;
    title?: string;
    modalBody?: JSX.Element;
    onHide?: () => void;
}

export const SusyCarouselModal = (props: SusyCarouselModalProps) => {
    return (
        <Modal
            show={props.show}
            size={props.size}
            aria-labelledby={props.ariaLabelledBy}
            centered={props.centered}
            id={props.id}
            data-testid={props.dataTestId}
        >
            <Modal.Body>{props.modalBody}</Modal.Body>
        </Modal>
    );
};
